import { Typography, useMediaQuery } from '@mui/material';
import { BooleanField, CreateButton, Datagrid, ImageField, List, NumberField, SimpleList, TextField, useResourceContext } from 'react-admin';

const AiPrizeList = () => {
	const isSmall = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
	const context = useResourceContext({ resource: 'ai-program-prize' });
	return (
		<List resource="ai-program-prize" hasCreate actions={<CreateButton resource="ai-program-prize" />}>
			{isSmall ? (
				<SimpleList
					resource={context}
					primaryText={(record) => (
						<Typography textAlign="right" fontWeight={'600'}>
							{`${record.title?.he || record._id}`}
						</Typography>
					)}
					secondaryText={(record) => <Typography>{record.sub_title?.he || ''}</Typography>}
				/>
			) : (
				<Datagrid dir="rtl" rowClick="edit" resource="ai-program-prize">
					<ImageField source="image" label="תמונה" />
					<TextField source="title.he" textAlign="right" label="כותרת (עברית)" />
					<TextField source="title.en" textAlign="left" label="כותרת (אנגלית)" />
					<TextField source="sub_title.he" textAlign="right" label="תת כותרת (עברית)" />
					<TextField source="sub_title.en" textAlign="left" label="תת כותרת (אנגלית)" />
					
					<NumberField source="points" textAlign="center" label="נקודות" />
					<TextField source="type" textAlign="center" label="סוג" />
					<BooleanField source="active" textAlign="center" label="פעיל" />
				</Datagrid>
			)}
		</List>
	);
};

export default AiPrizeList;
